<template>
  <div class="box">

    <div class="columns">

      <div class="column is-two-thirds">

        <!-- the new post title -->
        <div class="field">
          <label class="label">Books's title</label>
          <div class="control">
            <input type="text" class="input" placeholder="Title" v-model="post.title">
          </div>
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <div class="field">
        <label class="label">Synopsis</label>
        <quill-editor v-model="post.synopsis" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <label class="label">Excerpt</label>
        <quill-editor v-model="post.excerpt" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">

        <!-- rich text vue-quill-editor plugin -->
        <div class="field">
        <label class="label">About Author</label>
        <quill-editor v-model="post.author_text" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>

        <!-- Category field -->
        <!-- <br>
        <div class="field">
          <label class="label">Category</label>
          <div class="control">
            <input type="text" class="input" placeholder="Category" v-model="post.category" maxlength="25">
          </div>
        </div> -->

        <!-- editor -->
        <div class="field">
          <label class="label">Editor</label>
          <div class="control">
            <input type="text" class="input" placeholder="Editor" v-model="post.editor" maxlength="40" required>
            <p></p>
          </div>
        </div>

        <div class="field">
          <label class="label">Original</label>
          <div class="control">
            <input type="text" class="input" placeholder="Original Text Info" v-model="post.original" maxlength="200" required>
            <p></p>
          </div>
        </div>

        <div class="field">
          <label class="label">Rev.</label>
          <div class="control">
            <input type="text" class="input" placeholder="Revision" v-model="post.rev" required>
            <p></p>
          </div>
        </div>
        <div class="field">
          <label class="label">Cover</label>
          <div class="control">
            <input type="text" class="input" placeholder="CoverInfo" v-model="post.cover_info" maxlength="200" required>
            <p></p>
          </div>
        </div>

      </div>

      <!-- right sidebar -->
      <div class="column is-one-third">
        <div class="columns">
          <div class="column is-3">
            <!-- pdf params -->
            <div class="field">
              <label class="label">Font</label>
              <div class="control">
                <input type="text" class="input" placeholder="Font multiplier 1.1" v-model="post.font_multiplier" maxlength="25" required>
                <p></p>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <!-- pdf params -->
            <div class="field">
              <label class="label">Line</label>
              <div class="control">
                <input type="text" class="input" placeholder="1.15" v-model="post.line_height" maxlength="25" required>
                <p></p>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Book Size</label>
              <!--div class="control">
                <input type="text" class="input" placeholder="Paper size (1, 2, ...)" v-model="post.book_size" maxlength="25" required>
                <p></p>
              </div-->
              <div class="select">
                <select v-model="post.book_size">
                  <option>Book Size</option>
                  <option value="A5">A5</option>
                  <option value="0">5" x 8" (12.7 x 20.32 cm)</option>
                  <option value="1">5.25" x 8" (13.34 x 20.32 cm)</option>
                  <option value="2">5.5" x 8.5" (13.97 x 21.59 cm)</option>
                  <option value="3">6" x 9" (15.24 x 22.86 cm)</option>
                  <option value="4">HUGE (215.9 x 279.4 cm)</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-half">
            <!-- price -->
            <div class="field">
              <label class="label">Price Paper</label>
              <div class="control">
                <input type="text" class="input" placeholder="price for paper" v-model="post.price_paper" maxlength="25" required>
                <p></p>
              </div>
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Price Ebook</label>
              <div class="control">
                <input type="text" class="input" placeholder="price for ebook" v-model="post.price_ebook" maxlength="25" required>
                <p></p>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-one-quarter">
          <!-- year -->
          <div class="field">
            <label class="label">Year</label>
            <div class="control">
              <input type="text" class="input" placeholder="year" v-model="post.year" maxlength="25" required>
              <p></p>
            </div>
          </div>
       </div>

       <div class="column is-one-quarter">
        <div class="field">
          <label class="label">Edit.</label>
          <div class="control">
            <input type="text" class="input" placeholder="edit." v-model="post.edition" maxlength="25" required>
            <p></p>
          </div>
        </div>
       </div>

       <div class="column is-one-quarter">
        <div class="field">
          <label class="label">O. Year</label>
          <div class="control">
            <input type="text" class="input" placeholder="original publishing year" v-model="post.original_year" maxlength="25" required>
            <p></p>
          </div>
        </div>
       </div>

        <!-- pages_words -->
        <div class="column is-one-quarter">
          <div class="field">
            <label class="label">Pages</label>
            <div class="control">
              <input type="text" class="input" placeholder="pages" v-model="post.pages" maxlength="25" required>
              <p></p>
            </div>
          </div>
        </div>
       </div>

        <!-- isbn -->
        <div class="field">
          <label class="label">ISBN</label>
          <div class="control">
            <input type="text" class="input" placeholder="ISBN" v-model="post.isbn" maxlength="25" required>
            <p></p>
          </div>
        </div>

        <!-- Copyright Note -->
        <div class="field">
          <label class="label">Copyright Note</label>
          <div class="control">
            <input type="text" class="input" placeholder="ISBN" v-model="post.copyright" maxlength="250" required>
            <p></p>
          </div>
        </div>

        <!-- ortografia -->
        <div class="field">
          <label class="label">Ortografia</label>
          <div class="control">
            <input type="text" class="input" placeholder="OO: Ort. orig. | OA: Ort. act. (1945) | AO: Novo acordo ort. (1990)" v-model="post.orthography" maxlength="25" required>
            <p></p>
          </div>
        </div>

        <!-- author -->
        <!-- <div class="field">
          <label class="label">Author</label>
          <div class="control">
            <input type="text" class="input" placeholder="Author" v-model="post.author" maxlength="25" required>
            <p></p>
          </div>
        </div> -->

        <!-- authors -->
        <div class="field">
          <label class="label">Authors</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeAuthor(index)" v-for="(aut, index) in post.authors" :key="index" class="tag is-info pointer">{{aut}}<button class="delete is-small"></button></span>
            <input placeholder="Authors" @keypress.44.prevent="styleAuthors" @keyup.enter="styleAuthors" type="text" class="input" maxlength="25" v-model="inputDataAuthors">
            </div>
            <p>Separate authors with ENTER</p>
          </div>
        </div>

        <!-- translators -->
        <div class="field">
          <label class="label">Translators</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeTranslator(index)" v-for="(aut, index) in post.translators" :key="index" class="tag is-info pointer">{{aut}}<button class="delete is-small"></button></span>
            <input placeholder="Translators" @keypress.44.prevent="styleTranslators" @keyup.enter="styleTranslators" type="text" class="input" maxlength="25" v-model="inputDataTranslators">
            </div>
            <p>Separate with ENTER</p>
          </div>
        </div>

        <!-- categories -->
        <div class="field">
          <label class="label">Categories</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeCategory(index)" v-for="(cat, index) in post.categories" :key="index" class="tag is-info pointer">{{cat}}<button class="delete is-small"></button></span>
            <input placeholder="Categories" @keypress.44.prevent="styleCategories" @keyup.enter="styleCategories" type="text" class="input" maxlength="25" v-model="inputDataCategories">
            </div>
            <p>Separate Categories with ENTER</p>
          </div>
        </div>

        <!-- tags -->
        <!-- <div class="field">
          <label class="label">Tags</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeTag(index)" v-for="(tag, index) in post.tags" :key="index" class="tag is-info pointer">{{tag}}<button class="delete is-small"></button></span>
            <input placeholder="Tags" @keypress.44.prevent="styleTags" @keyup.enter="styleTags" type="text" class="input" maxlength="25" v-model="inputData">
            </div>
            <p>Seperate tags with commas</p>
          </div>
        </div> -->

        <hr>

        <div class="field">
          <label class="label">Cover (100x100px)</label>
          <div class="control">
            <img :src="post.cover">
            <div class="file">
              <label class="file-label">
                <input @change="uploadFeaturedImage" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">PDF</label>
          <div class="control">
            <a v-if="post.file_pdf" :href="post.file_pdf">file</a>
            <div class="file">
              <label class="file-label">
                <input @change="uploadPDF" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">EPub</label>
          <div class="control">
            <a v-if="post.file_epub" :href="post.file_epub">file</a>
            <div class="file">
              <label class="file-label">
                <input @change="uploadEpub" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

      </div> <!-- Right Sidebar -->

    </div>

    <!-- warning notification -->
    <div v-if="notification.message" :class="'notification is-' + notification.type">
      <button class="delete" @click="hideNotifications"></button>{{notification.message}}
    </div>

    <!-- the form buttons -->
    <a id="bottom"/>
    <button v-if="post.state === 'saved'" type="submit" class="button is-success" @click="update(true)">Update and publish</button>
    <button id="save_button" type="submit" class="button is-info" @click="update(false)">Update</button>
    <button id="export_button" type="submit" class="button is-info" @click="$refs.asyncComponentRef.exportPDF(post, fulltext)">Export PDF</button>
    <button id="export_button_ebook" type="submit" class="button is-info" @click="$refs.asyncComponentRef.exportPDF(post, fulltext, true)">Export eBook PDF</button>
    <button id="export_button_ebook" type="submit" class="button is-info" @click="$refs.asyncComponentRef.exportEPub(post, his.$route.params.key, fulltext, true)">Export eBook ePub</button>
    <router-link to="/admin/books" class="button is-danger">Cancel</router-link>
    <AsyncComponent ref="asyncComponentRef" />
  </div>
</template>

<script>
import firebase from 'firebase'
import utils from '@/mixins/utils'
import { mediaRef, textsRef, paramsRef } from '@/firebase_config'
import editorOptions from './editor-options-complete'
import imageLoader from '@/mixins/image-loader'
import notifier from '@/mixins/notifier'

export default {
  name: 'post-edit',
  components: {
    AsyncComponent: () => import('./AsyncComponent.vue')
  },
  data () {
    var self = this
    textsRef.child(this.$route.params.key).child('text').once('value').then(function (textSnapshot) {
      self.fulltext = self.fixDiacritics(textSnapshot.val())
    })
    return {
      /* Here we are filtering out the post containing the provided key in the router params
       * we are using Object.assign to copy the post by value not by reference
       * to prevent updating the poste when typing */
      inputData: '',
      inputDataCategories: '',
      inputDataTranslators: '',
      inputDataAuthors: '',
      fulltext: '',
      post: Object.assign(
        {},
        (this.posts.filter((post) => {
          return (post['.key'] === this.$route.params.key)
        }))[0]
      ),
      editorOptions
    }
  },
  firebase: {
    media: mediaRef
  },
  props: ['posts', 'update-post'],
  mixins: [utils, imageLoader, notifier, textsRef, paramsRef],
  methods: {
    exportPDF () {},
    // call the updatePost method passed through props
    update (publish) {
      if (this.post.title) {
        if (publish) {
          this.post.state = 'published'
        }
        this.updatePost(this.post, this.fulltext)
      } else {
        this.showNotification('warning', 'The title field can not be empty')
      }
    },
    uploadFeaturedImage (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        return snapshot.ref.getDownloadURL().then(downloadURL => {
          this.post.cover = downloadURL
          if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
          this.$firebaseRefs.media.push({
            src: downloadURL,
            path: snapshot.ref.fullPath,
            name: snapshot.metadata.name
          })
        })
      })
    },
    uploadPDF (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('ebooks/pdf/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.post.file_pdf = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    uploadEpub (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('ebooks/epub/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.post.file_epub = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    styleAuthors () {
      if (this.inputDataAuthors !== '') {
        if (!this.post.authors) {
          this.post.authors = []
        }
        this.post.authors.push(`${this.inputDataAuthors.trim()}`)
        this.inputDataAuthors = ''
      }
    },
    removeAuthor (index) {
      this.post.authors.splice(index, 1)
    },
    styleTranslators () {
      if (this.inputDataTranslators !== '') {
        if (!this.post.translators) {
          this.post.translators = []
        }
        this.post.translators.push(`${this.inputDataTranslators.trim()}`)
        this.inputDataTranslators = ''
      }
    },
    removeTranslators (index) {
      this.post.translators.splice(index, 1)
    },
    styleCategories () {
      if (this.inputDataCategories !== '') {
        this.post.categories.push(`${this.inputDataCategories.trim()}`)
        this.inputDataCategories = ''
      }
    },
    removeCategory (index) {
      this.post.categories.splice(index, 1)
    },
    styleTags () {
      if (this.inputData !== '') {
        this.tagString.push(`${this.inputData.trim()}`)
        this.inputData = ''
      }
    },
    removeTag (index) {
      this.tagString.splice(index, 1)
    }
  },
  mounted: function () {
    this.reloaded = false
    window.scrollTo(0, 0)
  },
  computed: {
    tagString: {
      get: function () {
        return this.post.tags // if no tags present join is undefined
      },
      set: function (newValue) {
        this.post.tags = newValue
      }
    }
  }
}
// save and export keyboard shortcuts
document.addEventListener('keydown', function (event) {
  if (event.code === 'KeyS' && (event.ctrlKey || event.metaKey)) {
    event.preventDefault()
    document.querySelector('#save_button').click()
    document.cookie = 'ScrollTop=' + document.documentElement.scrollTop
    console.log('Saved!')
  }
})
</script>
<style>
.ql-container {
  font-size: 1rem;
}

@media screen and (min-width: 1408px) {
  .bulma .container {
      max-width: 1300px;
      width: 1300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/BookEdit.vue